import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '../actions/user'
import api from '../../components/backend/backend-api'
import Vue from 'vue'
import router from '../../router'
import VueAnalytics from 'vue-analytics'
import {AUTH_ERROR, AUTH_LOGOUT, AUTH_SUCCESS} from '../actions/auth'

const state = { status: '', profile: {} , curUser:'', userDepartmentName:'', authorities:[], curCustomer:'', currentCustomerLogicalId: '', curRiskMatrixType: '', availableLanguages:'', languages:['en','no','se'], productionEnvironment:true}

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name,
  curUser:state => state.curUser,
  userDepartmentName:state => state.userDepartmentName,
  authorities: state =>state.authorities,
  curCustomer:state =>state.curCustomer,
  currentCustomerLogicalId:state=>state.currentCustomerLogicalId,
  curRiskMatrixType:state=>state.curRiskMatrixType,
  availableLanguages:state=>state.availableLanguages,
  allLanguages:state=>state.languages,
  productionEnvironment:state=>state.productionEnvironment
}

const actions = {
  [USER_REQUEST]: ({commit, dispatch}) => {

    api.getUserInformation().then(response => {
      if (response.authenticated) {
      state.authorities = response.authorities
      state.curUser = response.completeName
        state.userDepartmentName = response.userDepartmentName
        commit(AUTH_SUCCESS)
        api.setCurrentCustomer().then(response => {
          state.curCustomer = response.name
          state.currentCustomerLogicalId = response.logicalName
          state.availableLanguages = response.availableLanguages
          state.curRiskMatrixType = response.riskMatrixType
          api.getConfig().then(response=> {
            state.productionEnvironment = response.productionEnvironment
          })
  //   router.push("/")
        })

    } else{
        commit(AUTH_ERROR)
        state.authorities = []
        state.curUser = ''
        state.departmentName = ''
        state.curCustomer = ''
        state.currentCustomerLogicalId = ''
        state.availableLanguages = state.languages
      }
      //     commit('setAuthorities', response)
    })
    commit(USER_REQUEST)
/**    api.hello()
      .then(resp => {
        commit(USER_SUCCESS, resp)
      })
      .catch(resp => {
        commit(USER_ERROR)
        // if resp is unauthorized, logout, to
        dispatch(AUTH_LOGOUT)
      })

 **/
  },
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.authorities =[]
    state.curUser=''
    state.curCustomer = ''
    state.currentCustomerLogicalId = ''
    state.availableLanguages = state.languages

  },
  setAuthorities(state, authorities) {
    state.authorities = authorities;
  },
  setCurUser(state, user) {
    state.curUser = user;
  },
  setCustomer(state, customer) {
    state.curCustomer = customer

  },
  setCustomerLogicalId(state, customerLogicalId) {
    state.currentCustomerLogicalId = customerLogicalId
  },
  setRiskMatrixType(state, riskMatrixType) {
    state.curRiskMatrixType = riskMatrixType
  },

  setAvailableLanguages(state, availableLanguages) {
    state.availableLanguages = availableLanguages
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
